import {
  IPurchaseTransaction,
  ITransferTransaction,
  TransactionData
} from '@/services/types/TransactionData';
import { TTransactionHistory } from '../types/TransactionHistory';
import { TAccountCard } from '../types/Card';
import { TWalletData } from '../types/WalletData';
import { isCredit } from './isCredit';

export const transformTransactionHistoryData = (data: {
  transformedTransaction: TTransactionHistory;
  cards: TAccountCard[];
  wallets: TWalletData[];
}): TTransactionHistory => {
  const { transformedTransaction, cards, wallets } = data;

  transformedTransaction.wallet = wallets.find(
    (wallet) => wallet.id === transformedTransaction.data.walletId
  );

  // Handle purchase transaction type
  if (typeCheckPurchaseData(transformedTransaction.data)) {
    const purchaseTransaction = transformedTransaction.data as IPurchaseTransaction;
    data.transformedTransaction.card = cards.find((card) => card.id === purchaseTransaction.cardId);
  }

  // Handle account transfer transaction type
  if (typeCheckTransferData(transformedTransaction.data)) {
    const transferTransaction = transformedTransaction.data as ITransferTransaction;

    if (isCredit(transferTransaction.sign)) {
      transformedTransaction.wallet = wallets.find(
        (wallet) => wallet.id === transferTransaction.otherWalletId
      );
      transformedTransaction.toWallet = wallets.find(
        (wallet) => wallet.id === transferTransaction.walletId
      );
    } else {
      transformedTransaction.wallet = wallets.find(
        (wallet) => wallet.id === transferTransaction.walletId
      );
      transformedTransaction.toWallet = wallets.find(
        (wallet) => wallet.id === transferTransaction.otherWalletId
      );
    }
  }

  return transformedTransaction;
};

export const typeCheckTransferData = (data: TransactionData): data is ITransferTransaction => {
  return 'otherWalletId' in data;
};

export const typeCheckPurchaseData = (data: TransactionData): data is IPurchaseTransaction => {
  return 'cardId' in data;
};
